import React from 'react';
import { Target, Lightbulb, Users, TrendingUp } from 'lucide-react';
export function Mission() {
  return <section id="mission" className="py-24 bg-[#0a1628] relative overflow-hidden" data-id="element-105">
      {/* Modern Background Pattern */}
      <div className="absolute inset-0 opacity-20" data-id="element-106">
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-soft-light" data-id="element-107"></div>
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#f59e0b]/20 via-transparent to-transparent" data-id="element-108"></div>
        <div className="absolute bottom-0 left-0 w-full h-full bg-[radial-gradient(circle_at_bottom_left,_var(--tw-gradient-stops))] from-blue-600/20 via-transparent to-transparent" data-id="element-109"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-110">
        <div className="grid lg:grid-cols-2 gap-20 items-center" data-id="element-111">
          <div data-id="element-112">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-6" data-id="element-113">
              <span className="w-2 h-2 rounded-full bg-[#f59e0b]" data-id="element-114"></span>
              <span className="text-xs text-gray-300 font-bold tracking-widest uppercase" data-id="element-115">
                Our Vision
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-116">
              Reshaping the <br data-id="element-117" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#f59e0b] to-orange-400" data-id="element-118">
                Digital Future
              </span>
            </h2>

            <div className="glass-panel-dark p-8 rounded-2xl mb-8 transform hover:scale-[1.02] transition-transform duration-300 border-l-4 border-[#f59e0b]" data-id="element-119">
              <p className="text-xl text-gray-200 leading-relaxed font-light italic" data-id="element-120">
                "To reshape the UAE tech landscape by introducing cutting-edge
                innovations and securing the digital future of the region."
              </p>
            </div>

            <p className="text-gray-400 mb-10 leading-relaxed text-lg" data-id="element-121">
              We are driven by a passion for technology and a commitment to
              excellence. Our goal is not just to provide services, but to be a
              catalyst for digital transformation across the Emirates.
            </p>

            <div className="grid sm:grid-cols-3 gap-6" data-id="element-122">
              {[{
              icon: <Target data-id="element-123" />,
              label: 'Precision'
            }, {
              icon: <Lightbulb data-id="element-124" />,
              label: 'Innovation'
            }, {
              icon: <Users data-id="element-125" />,
              label: 'Partnership'
            }].map((item, idx) => <div key={idx} className="group text-center p-6 rounded-xl bg-white/5 border border-white/5 hover:bg-white/10 hover:border-[#f59e0b]/30 transition-all duration-300" data-id="element-126">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#f59e0b] to-orange-600 rounded-xl flex items-center justify-center mx-auto mb-4 text-white shadow-lg shadow-orange-500/20 group-hover:scale-110 group-hover:rotate-3 transition-all duration-300" data-id="element-127">
                    {item.icon}
                  </div>
                  <h3 className="text-white font-bold text-lg" data-id="element-128">{item.label}</h3>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-129">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#f59e0b] to-blue-600 rounded-2xl opacity-30 blur-2xl animate-pulse-glow" data-id="element-130"></div>
            <img src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop" alt="Cybersecurity Technology" className="relative rounded-2xl shadow-2xl border border-white/10 w-full" data-id="element-131" />

            {/* Stats Card - Improved positioning and design */}
            <div className="absolute -bottom-8 -left-8 bg-gradient-to-br from-[#0a1628] to-[#1a2a48] p-6 rounded-2xl border border-[#f59e0b]/30 shadow-2xl max-w-xs backdrop-blur-sm" data-id="element-132">
              <div className="flex items-center gap-4 mb-3" data-id="element-133">
                <div className="w-12 h-12 bg-[#f59e0b] rounded-xl flex items-center justify-center" data-id="element-134">
                  <TrendingUp className="w-6 h-6 text-white" data-id="element-135" />
                </div>
                <div data-id="element-136">
                  <span className="text-4xl font-bold text-white" data-id="element-137">98%</span>
                  <span className="text-[#f59e0b] text-sm font-bold ml-2" data-id="element-138">
                    Success
                  </span>
                </div>
              </div>
              <div className="w-full bg-gray-700/50 h-2 rounded-full overflow-hidden" data-id="element-139">
                <div className="bg-gradient-to-r from-[#f59e0b] to-orange-600 h-full w-[98%] rounded-full" data-id="element-140"></div>
              </div>
              <p className="text-gray-400 text-xs mt-2" data-id="element-141">
                Client satisfaction rate
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}